import React, { useEffect, useState } from 'react';
import moment from 'moment';
import * as insightsAPI from '@debbie/cortex/dist/api/insights.js';
import PerformedBy from './PerformedBy.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
import THEME from '../../theme.js';
import { useSelector } from 'react-redux';
import Badge from '../Badge.js';
const BulkActionPreview = (props) => {
    const lang = useSelector((s) => s.lang);
    const [bulkAction, setBulkAction] = useState(null);
    useEffect(() => {
        if (!bulkAction) {
            insightsAPI
                .getBulkAction(props.id)
                .then((data) => {
                setBulkAction(data);
            })
                .catch((error) => {
                console.error('Error fetching bulk action:', error);
            });
        }
    }, []);
    return (React.createElement("div", null, bulkAction ? (React.createElement("div", null,
        React.createElement("p", null,
            React.createElement(Badge, { theme: THEME.COLOR_ACCENT }, lang.bulkActionTypes[bulkAction.action.type])),
        React.createElement("p", null,
            React.createElement(PerformedBy, { performedBy: bulkAction.performedBy }),
            ' ',
            moment(bulkAction.createdAt).format(THEME.DATE_FORMAT_LONG)))) : (React.createElement(PlaceholderLoader, null))));
};
export default BulkActionPreview;
//# sourceMappingURL=BulkActionPreview.js.map